import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { CiptechGuardsModule, CiptechHttpModule, CiptechServicesModule, WsGlobalService } from '@ciptech/commons';
// Toastr module
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { BrowserPrintComponent } from './features/browser-print/browser-print.component';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { EncuestaComponent } from './features/encuesta/encuesta.component';
// import { StartUpService } from './startup.service';

// La función exportada para ejecutar los proveedores antes que arranque angular
// export function appProviderFactory(provider: StartUpService) {
//   return () => provider.getConfigs();
// }

const cookieConfig: NgcCookieConsentConfig = {
	cookie: {
		// domain: "localhost", // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
		domain: window.location.hostname
	},
	position: "bottom",
	theme: "classic",
	palette: {
		popup: {
			background: "#000000",
			text: "#ffffff",
			link: "#a29e9e"
		},
		button: {
			background: "#7daf00",
			text: "#ffffff",
			border: "transparent"
		}
	},
	type: "info",
	// layout: 'my-custom-layout',
	// layouts: {
	//   "my-custom-layout": '{{messagelink}}{{compliance}}'
	// },
	// elements:{
	//   messagelink: `
	//   <span id="cookieconsent:desc" class="cc-message">{{message}} 
	//     <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{cookiePolicyHref}}" target="_blank">{{cookiePolicyLink}}</a>, 
	//     <a aria-label="learn more about our privacy policy" tabindex="1" class="cc-link" href="{{privacyPolicyHref}}" target="_blank">{{privacyPolicyLink}}</a> and our 
	//     <a aria-label="learn more about our terms of service" tabindex="2" class="cc-link" href="{{tosHref}}" target="_blank">{{tosLink}}</a>
	//   </span>
	//   `,
	// },
	content: {
		message: "Este sitio utiliza cookies para garantizar que obtenga la mejor experiencia en nuestro sitio web.",
		dismiss: "Permitir cookies",
		deny: "Rechazar cookies",
		link: "Saber más...",
		href: window.location.origin + '/politicas/cookies',
		allow: "Permitir cookies",
		policy: "Política Cookies"
	}
};

@NgModule({
	declarations: [
		AppComponent,
		NotFoundComponent,
		BrowserPrintComponent,
		EncuestaComponent
	],
	imports: [
		BrowserModule,
		CiptechGuardsModule,
		CiptechServicesModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		//HttpClientModule, // --> No importamos todo el modulo CiptechHttp
		CiptechHttpModule,
		ToastrModule.forRoot({
			timeOut: 3000,
			positionClass: 'toast-bottom-right',
			preventDuplicates: true,
			closeButton: true,
			// toastClass: 'ngx-toastr animate__animated animate__bounceInUp'
		}),
		NgcCookieConsentModule.forRoot(cookieConfig)
	],
	providers: [
		WsGlobalService
		// StartUpService,
		// {
		//   provide: APP_INITIALIZER,
		//   useFactory: appProviderFactory,
		//   deps: [StartUpService],
		//   multi: true
		// }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
